<template>
  <div :class="['flex', message.direction === 'outbound' ? 'justify-end' : 'justify-start']">
    <div
      :class="[
        'max-w-md px-4 py-3 rounded-lg shadow-sm',
        message.direction === 'outbound'
          ? 'bg-primary-500 text-white rounded-br-none'
          : 'bg-white text-gray-900 rounded-bl-none border border-gray-200'
      ]"
    >
      <p class="whitespace-pre-wrap break-words">{{ message.content }}</p>
      
      <div
        :class="[
          'flex items-center gap-1 mt-1 text-xs',
          message.direction === 'outbound' ? 'text-primary-100 justify-end' : 'text-gray-500'
        ]"
      >
        <span>{{ formatTime(message.created_at) }}</span>
        
        <!-- Status indicators for outbound messages -->
        <template v-if="message.direction === 'outbound'">
          <!-- Pending/Sending -->
          <ClockIcon v-if="message.status === 'pending'" class="w-4 h-4" />
          
          <!--Sent (single check) -->
          <CheckIcon v-else-if="message.status === 'sent'" class="w-4 h-4" />
          
          <!-- Delivered/Read (double check) -->
          <div v-else-if="message.status === 'delivered' || message.status === 'read'" class="flex">
            <CheckIcon class="w-4 h-4 -mr-2" />
            <CheckIcon class="w-4 h-4" />
          </div>
          
          <!-- Failed -->
          <ExclamationCircleIcon 
            v-else-if="message.status === 'failed'" 
            class="w-4 h-4 text-red-300" 
            title="Falha no envio"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CheckIcon, ClockIcon, ExclamationCircleIcon } from '@heroicons/vue/24/solid'
import { format } from 'date-fns'

const props = defineProps({
  message: { type: Object, required: true }
})

function formatTime(timestamp) {
  if (!timestamp) return ''
  try {
    return format(new Date(timestamp), 'HH:mm')
  } catch (error) {
    return ''
  }
}
</script>
